import { z } from 'zod';
import { isoUtcDateTimeSchema } from './date-time-schema';

export const viewSnapshotScheduleSchema = z
  .object({
    itemId: z.number().int(),
    forecastedStartDateTime: isoUtcDateTimeSchema.nullable().optional(),
    forecastedFinishDateTime: isoUtcDateTimeSchema.nullable().optional(),
    // Legacy field names — present in pre-rename (NEX-14462) view lock snapshots.
    expectedStartDateTime: isoUtcDateTimeSchema.nullable().optional(),
    expectedFinishDateTime: isoUtcDateTimeSchema.nullable().optional(),
    latestFinishDateTime: isoUtcDateTimeSchema.nullable(),
  })
  .transform((data) => ({
    itemId: data.itemId,
    forecastedStartDateTime: data.forecastedStartDateTime ?? data.expectedStartDateTime ?? null,
    forecastedFinishDateTime: data.forecastedFinishDateTime ?? data.expectedFinishDateTime ?? null,
    latestFinishDateTime: data.latestFinishDateTime,
  }));

export type ViewSnapshotScheduleDTO = z.infer<typeof viewSnapshotScheduleSchema>;
